<template>
  <div id="paywall" v-show="show">
    <div id="pay-modal">
      <div class="close" @click="closeModal()">
        <mu-icon-button icon="close" />
      </div>
      <div class="block">
        <p v-text="$t('message.paymentModalFeatureNotAvailable')"></p>
      </div>
      <div class="block">
        <div class="icon">
          <mu-icon value="lock" :size="50" color="#0179d5" />
        </div>
      </div>
      <div class="block">
        <p>{{ $t('message.paymentModalUpgrade') }} <strong v-html="$sanitize(paypal.currency_sym + paypal.amount)"></strong></p>
      </div>
      <mu-flat-button backgroundColor="#0179d5" to="payment" type="button" :label="$t('message.paymentModalProceedPayment')" fullWidth />
    </div>
  </div>
</template>

<script>
  import paymentApi from '../../../api/Payment';
  import EventBus from '../../../helpers/EventBus';
  export default {
    name: 'paywall',
    props: {
      show: {
        required: true,
        type: Boolean,
        default: true,
      }
    },
    data() {
      return {
        paypal: {},
      }
    },
    methods: {
      fetchPaymentDetails() {
        let self = this;
        paymentApi.getPayPalDetails().then(response => {
          self.paypal = response.data;
        }).catch(error => {
        });
      },
      initMounted() {
        let self = this;
        self.show = false;
        self.fetchPaymentDetails();
      },
      closeModal() {
        let self = this;
        self.show = false;
        EventBus.$emit('App::triggerPaywall', false);
      }
  },
  mounted() {
      let self = this;
      $('#paywall').mousedown(function(e) {
        if(($(e.target).attr('id') === 'paywall')) {
          self.closeModal();
        }
      });
      self.initMounted();
    }
  }

</script>

<style lang="less">
  @import "../../../styles/theme.less";
  #paywall {
    width: 100%;
    height: 100%;
    background: fade(#000, 70%);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    #pay-modal {
      width: 100%;
      max-width: 400px;
      padding: 44px;
      font-size: 16px;
      color: @primaryColor;
      text-align: center;
      border-radius: 4px;
      background: #FFF;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      position: absolute;
      top: 50%;
      left: 50%;
      .block {
        padding: 0 0 30px;
        p {
          margin: 0 0 16px;
        }
      }
      .close {
        position: absolute;
        top: 10px;
        right: 10px;
      }
      .mu-flat-button {
        display: block;
        width: 100%;
        height: 45px;
        line-height: normal;
        border-radius: 6px;
        .mu-flat-button-label {
          color: #FFF;
          font-weight: 500;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Paywall.vue?ace68dee